var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDustbinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 3.00016H13.6666V4.3335H12.3333V13.0002C12.3333 13.177 12.263 13.3465 12.138 13.4716C12.013 13.5966 11.8434 13.6668 11.6666 13.6668H2.33325C2.15644 13.6668 1.98687 13.5966 1.86185 13.4716C1.73682 13.3465 1.66659 13.177 1.66659 13.0002V4.3335H0.333252V3.00016H3.66659V1.00016C3.66659 0.823352 3.73682 0.653782 3.86185 0.528758C3.98687 0.403734 4.15644 0.333496 4.33325 0.333496H9.66659C9.8434 0.333496 10.013 0.403734 10.138 0.528758C10.263 0.653782 10.3333 0.823352 10.3333 1.00016V3.00016ZM10.9999 4.3335H2.99992V12.3335H10.9999V4.3335ZM4.99992 6.3335H6.33325V10.3335H4.99992V6.3335ZM7.66659 6.3335H8.99992V10.3335H7.66659V6.3335ZM4.99992 1.66683V3.00016H8.99992V1.66683H4.99992Z",
    fill: "#5D737E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbinIcon);
export default __webpack_public_path__ + "static/media/dustbin_icon.db1030ab938adf3d9f9554a9e751e38d.svg";
export { ForwardRef as ReactComponent };